export default __webpack_public_path__ + "static/media/CarImages.PRunnerGallery3.16ebaae2.jpg";